export function EndUserCreateFormValidation() {
    var pattern = new RegExp('P.[O.]*\\s?B(ox)?.*\\d+', 'i');
    var result = true;

    if ($('#prefixField').val() == '') {
        result = false;
        $('#prefixField').showValidator('Please enter prefix for your company in Microsoft partner domain', 'error', 'right');
    }
    else if ($('#prefixField').hasClass('not-available')) {
        $('#prefixField').showValidator('This prefix is already taken, please choose another prefix', 'error', 'right');
        result = false;
    }

    if ($('#csptabs #userNameField').val() == '') {
        result = false;
        $('#csptabs #userNameField').showValidator('Please enter login user name', 'error', 'right');
    }
    else {
        var nameRegex = /^[0-9a-zA-Z-_.]{3,15}$/;

        if (!nameRegex.test($('#userNameField').val())) {
            $('#userNameField').showValidator("Special characters aren't allowed in user name, minimum 3 letters required and 15 maximum", 'error', 'right');
            result = false;
        }
    }

    if ($('#csptabs #firstNameField').val() == '') {
        result = false;
        $('#csptabs #firstNameField').showValidator('Please enter first  name', 'error', 'right');
    }

    if ($('#csptabs #lastNameField').val() == '') {
        result = false;
        $('#csptabs #lastNameField').showValidator('Please enter last name', 'error', 'right');
    }

    if ($('#csptabs #companyNameField').val() == '') {
        result = false;
        $('#csptabs #companyNameField').showValidator('Please enter company name', 'error', 'right');
    }

    if ($('#csptabs #emailField').val() == '' || !ValidateEmail($('#csptabs #emailField').val())) {
        result = false;
        $('#csptabs #emailField').showValidator('Please enter valid email address', 'error', 'right');
    }

    if ($('#csptabs #addressLine1Field').val() == '') {
        result = false;
        $('#csptabs #addressLine1Field').showValidator('Please enter address', 'error', 'right');
    }
    else if ($('#csptabs #addressLine1Field').val().match(pattern)) {
        result = false;
        $('#csptabs #addressLine1Field').showValidator('Delivery to a PO Box is not allowed', 'error', 'right');
    }

    if ($('#csptabs #addressLine2Field').val() != '' && $('#csptabs #addressLine2Field').val().match(pattern)) {
        result = false;
        $('#csptabs #addressLine2Field').showValidator('Delivery to a PO Box is not allowed', 'error', 'right');
    }

    if ($('#csptabs #addressLine3Field').val() != '' && $('#csptabs #addressLine3Field').val().match(pattern)) {
        result = false;
        $('#csptabs #addressLine3Field').showValidator('Delivery to a PO Box is not allowed', 'error', 'right');
    }

    if ($('#csptabs #suburbField').val() == '') {
        result = false;
        $('#csptabs #suburbField').showValidator('Please enter suburb', 'error', 'right');
    }

    if ($('#csptabs #stateField').val() == '') {
        result = false;
        $('#csptabs #stateField').showValidator('Please choose state', 'error', 'right', true);
    }
    if ($('#csptabs #postCodeField').val() == '') {
        result = false;
        $('#csptabs #postCodeField').showValidator('Please enter postcode', 'error', 'right');
    }

    if ($('#csptabs #phoneField').val() == '') {
        result = false;
        $('#csptabs #phoneField').showValidator('Please enter phone number', 'error', 'right');
    }
    return result;
}

export function CreateEndUserInMicrosoft() {
    var result = EndUserCreateFormValidation();
    if (result) {
        $.ajax({
            type: "POST",
            url: 'api/Checkout/CreateCSPTenant',
            data: { formCollection: $('#addressenduser').serialize() },
            success: function (data) {
                if (data.result == 'Success') {
                    var cspTenant = [];
                    cspTenant.push({
                        tenantId: data.tenantId,
                        euName: $('#addressenduser #firstNameField').val() + ' ' + $('#csptabs #lastNameField').val(),
                        address: $('#addressenduser #addressLine1Field').val() + ' ' + $('#csptabs #addressLine2Field').val() + ' ' + $('#csptabs #addressLine3Field').val() + ' ' + $('#csptabs #suburbField').val() + ' ' + $('#csptabs #stateField_Input').val() + ' ' + $('#csptabs #postCodeField').val(),
                        email: $('#addressenduser #emailField').val(),
                        name: $('#addressenduser #companyNameField').val(),
                        phone: $('#addressenduser #phoneField').val(),
                        status: 'Active',
                        total: '0',
                        type: 'CSP'
                    });
                    var tenant_popup = $('#tenant_details');
                    tenant_popup.find('#TenantID').text(cspTenant[0].tenantId);
                    tenant_popup.find('#CompanyName').text(cspTenant[0].name);
                    tenant_popup.find('#TenantDomain').text($('#addressenduser #prefixField').val() + '.onmicrosoft.com');
                    var userName = $('#csptabs #userNameField').val() + '@@' + $('#csptabs #prefixField').val() + '.onmicrosoft.com';
                    tenant_popup.find('#TenantUserName').text(userName);
                    tenant_popup.find('#TenantPassword').text(data.password);
                    tenant_popup.find('#TenantFirstName').text($('#addressenduser #firstNameField').val());
                    tenant_popup.find('#TenantLastName').text($('#addressenduser #lastNameField').val());
                    tenant_popup.find('#TenantEmail').text($('#addressenduser #emailField').val());
                    $('#tenantmodal').foundation('open');
                }
                else {
                    $('#btnCreateEndUser div').showValidator(data.info, 'error', 'right');
                }
            }
        });
    }
}

export function AssociateEndUserWithMicrosoft() {

    var result = EndUserAssociateFormValidation();
    if (result) {
        $.ajax({
            type: "POST",
            url: 'api/Checkout/AssociateCSPTenant',
            data: $('#associateCSPTenant_form').serialize(),
            success: function (data) {
                if (data.result == 'Success') {
                    var cspTenant = [];
                    cspTenant.push({
                        tenantId: data.tenantId,
                        email: $('#csptabs #associateEmailField').val(),
                        name: $('#csptabs #associateCompanyNameField').val(),
                        status: 'Pending Association',
                        type: 'CSP'
                    });

                    var tenant_popup = $('#divTenantAssociationPopup #tenant_details');
                    tenant_popup.find('#TenantID').text(cspTenant[0].tenantId);
                    tenant_popup.find('#CompanyName').text(cspTenant[0].name);
                    var domain = $('#divAssociate #domainField').val();

                    if (domain.indexOf('.onmicrosoft.com') < 0) {
                        domain += ".onmicrosoft.com";
                    }

                    tenant_popup.find('#TenantDomain').text(domain);
                    tenant_popup.find('#TenantEmail').text(cspTenant[0].email);
                    $('#divTenantAssociationPopup').foundation('open');
                }
                else {
                    $('#btnAssociateEndUser div').showValidator(data.info, 'error', 'right');
                }
            }
        });
    }
}

function ValidateEmail(email) {
    
    var pattern = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,20}$/;

    if (!pattern.test(email) && email != '') {
        return false;
    }
    else {
        return true;
    }

}

function EndUserAssociateFormValidation() {

    var result = true;

    if ($('#companyIdField').val() == '') {
        result = false;
        $('#domainField').showValidator('Please enter valid company domain', 'error', 'right');
    }

    if ($('#associateCompanyNameField').val() == '') {
        result = false;
        $('#associateCompanyNameField').showValidator('Please enter company name', 'error', 'right');
    }

    if ($('#associateEmailField').val() == '' || !ValidateEmail($('#associateEmailField').val())) {
        result = false;
        $('#associateEmailField').showValidator('Please enter valid email address', 'error', 'right');
    }

    return result;
}

export function Validate_CSP_Tenant(type, mpnId, cartId, tenantId, showEmail) {

    var isValid = true;

    var email = '';

    // if (!mpnId) {
    //     isValid = false;
    //     $('#tenant_next').showValidator('Please Enter New Or Select MPN ID', 'error');
    // }
    if (mpnId) {
        // verify MPN id
        $.ajax({
            type: "GET",
            url: 'api/Checkout/GetPartnerByMPNId?mpnId=' + mpnId,
            async: false,
            success: function (data) {
                if (data.result != 'Success') {
                    $('#tenant_next').showValidator(data.info, 'error');
                    isValid = false;
                }
            }
        });
    }

    if (showEmail != '0') {
        var email = $('#defaultOwnerEmail').val();
        if (!email || !ValidateEmail(email)) {
            $('#tenant_next').showValidator('Please enter default owner email for this USAGE subscription', 'error');
            isValid = false;
        }
        else {
            var email = $('#defaultOwnerEmail').val();
            // check if this email address is a valid local domain user or external user
            $.ajax({
                type: "GET",
                url: 'api/Checkout/CheckSubscriptionOwnerEmailStatus?emailAddress=' + email + "&tenantId=" + tenantId,
                contentType: 'application/json; charset=utf-8',
                async: false,
                success: function (data) {
                    if (data.result == 'Fail' && data.info != 'UNKNOWN ERROR') {
                        $('#tenant_next').showValidator(data.info, 'error', 'right', false, true);
                        isValid = false;
                    }
                }
            });
        }
    }

    // if (isValid) {
    //     if (typeof tenantId != undefined && tenantId.length && mpnId != null && mpnId.length) {
    //         // Check existing subscription in MS for this tenant
    //         $.ajax({
    //             type: "GET",
    //             url: 'api/Checkout/CheckMSCustomerSubscription?tenantId=' + tenantId + "&mpn_id=" + mpnId + "&cartId=" + cartId,
    //             async: false,
    //             success: function (data) {
    //                 if (data.result != 'Success') {
    //                     $('#tenant_next').showValidator('This tenant already has the below subscriptions. <br /> ' + data.subscription_names + '<br /> Please remove it from cart and checkout. If you want to buy the same subscription, please go manage page and increase the quantity.', 'error', 'right', true, true, '', false);
    //                     isValid = false;
    //                 }
    //             }
    //         });
    //     }
    // }

    return isValid;
}

export function CreateADEndUser() {
    var result = ADEndUserCreateFormValidation();
    if (result) {
        $.ajax({
            type: "POST",
            url: 'api/Checkout/CreateADTenant',
            data: $('#createADTenant_form').serialize(),
            success: function (data) {
                if (data.result == 'Success') {
                    $('#btnCreateADEndUser .button').showValidator(data.info, 'success', 'right');
                    // save tenant info into js array
                    // cspTenant = [];
                    // cspTenant.push({
                    //     tenantId: data.tenantId,
                    //     euName: $('#firstNameField').val() + ' ' + $('#lastNameField').val(),
                    //     address: $('#addressLine1Field').val() + ' ' + $('#addressLine2Field').val() + ' ' + $('#addressLine3Field').val() + ' ' + $('#suburbField').val() + ' ' + $('#stateField_Input').val() + ' ' + $('#postCodeField').val(),
                    //     email: $('#emailField').val(),
                    //     name: $('#companyNameField').val(),
                    //     phone: $('#phoneField').val(),
                    //     status: 'Active',
                    //     total: '0'
                    // });

                    return data;
                }
                else {
                    $('#tenant_next').showValidator(data.info, 'error', 'right');
                }
            }
        });
    }
}

export function ADEndUserCreateFormValidation() {

    var result = true;
    var pattern = new RegExp('P.[O.]*\\s?B(ox)?.*\\d+', 'i');

    if ($('#ADKfirstNameField').val() == '') {
        result = false;
        $('#ADKfirstNameField').showValidator('Please enter first name', 'error', 'right');
    }

    if ($('#ADKlastNameField').val() == '') {
        result = false;
        $('#ADKlastNameField').showValidator('Please enter last name', 'error', 'right');
    }

    if ($('#ADKcompanyNameField').val() == '') {
        result = false;
        $('#ADKcompanyNameField').showValidator('Please enter company name', 'error', 'right');
    }

    if ($('#ADKcompanyDescField').val() == '') {
        result = false;
        $('#ADKcompanyDescField').showValidator('Please enter company description', 'error', 'right');
    }

    if ($('#ADKemailField').val() == '' || !ValidateEmail($('#ADKemailField').val())) {
        result = false;
        $('#ADKemailField').showValidator('Please enter valid email address', 'error', 'right');
    }

    if ($('#ADKaddressLine1Field').val() == '') {
        result = false;
        $('#ADKaddressLine1Field').showValidator('Please enter address', 'error', 'right');
    }
    else if ($('#ADKaddressLine1Field').val().match(pattern)) {
        result = false;
        $('#ADKaddressLine1Field').showValidator('Delivery to a PO Box is not allowed', 'error', 'right');
    }

    if ($('#ADKaddressLine2Field').val() != '' && $('#addressLine2Field').val().match(pattern)) {
        result = false;
        $('#ADKaddressLine2Field').showValidator('Delivery to a PO Box is not allowed', 'error', 'right');
    }

    if ($('#ADKaddressLine3Field').val() != '' && $('#addressLine3Field').val().match(pattern)) {
        result = false;
        $('#ADKaddressLine3Field').showValidator('Delivery to a PO Box is not allowed', 'error', 'right');
    }

    if ($('#ADKsuburbField').val() == '') {
        result = false;
        $('#ADKsuburbField').showValidator('Please enter suburb', 'error', 'right');
    }

    if ($('#ADKstateField').val() == '') {
        result = false;
        $('#ADKstateField').showValidator('Please choose state', 'error', 'right', true);
    }
    if ($('#ADKpostCodeField').val() == '') {
        result = false;
        $('#ADKpostCodeField').showValidator('Please enter postcode', 'error', 'right');
    }

    if ($('#ADKphoneField').val() == '') {
        result = false;
        $('#ADKphoneField').showValidator('Please enter phone number', 'error', 'right');
    }

    if ($('#resellerMPNId_Input').val() == '') {
        result = false;
        $('#resellerMPNId_Input').showValidator('Please select reseller CSN', 'error', 'right');
    }

    return result;
}